import { Link, useNavigate, useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { CONSENT_VERSIONS } from '@il-colpo/shared/account';
import { Badge, Button, Panel, ScreenFrame } from '../../ui/index.ts';
import { NotFound } from '../NotFound.tsx';
import styles from './Account.module.css';
import { Page } from './common.tsx';

const SECTIONS = ['s1', 's2', 's3', 's4', 's5', 's6', 's7', 's8'] as const;

/** The Terms of use and the Privacy notice: drafts, and the page says so. */
export function LegalScreen() {
  const { t } = useTranslation('legal');
  const { doc } = useParams();
  if (doc !== 'terms' && doc !== 'privacy') return <NotFound />;
  return (
    <ScreenFrame title={t(`${doc}.title`)} backTo="/account">
      <Page>
        <Panel tone="lamp">
          <div className={styles['row']}>
            <Badge tone="amber">{t('updated', { version: CONSENT_VERSIONS[doc] })}</Badge>
            <span role="note">{t('draftBanner')}</span>
          </div>
        </Panel>
        <Panel>
          <div className={styles['stack']}>
            {SECTIONS.map((id) => (
              <section key={id} className={styles['legalSection']}>
                <h2>{t(`${doc}.sections.${id}.heading`)}</h2>
                <p>{t(`${doc}.sections.${id}.body`)}</p>
              </section>
            ))}
          </div>
        </Panel>
        <p className={styles['note']}>
          <Link className={styles['link']} to={doc === 'terms' ? '/legal/privacy' : '/legal/terms'}>
            {t(doc === 'terms' ? 'links.privacy' : 'links.terms')}
          </Link>
        </p>
      </Page>
    </ScreenFrame>
  );
}

/** The page the stores ask for: how to delete the account, readable without signing in. */
export function DeleteAccountScreen() {
  const { t } = useTranslation('legal');
  const navigate = useNavigate();
  return (
    <ScreenFrame title={t('deleteAccount.title')} backTo="/">
      <Page>
        <Panel>
          <div className={styles['stack']}>
            <p>{t('deleteAccount.intro')}</p>
            <ol className={styles['steps']}>
              <li>{t('deleteAccount.steps.s1')}</li>
              <li>{t('deleteAccount.steps.s2')}</li>
              <li>{t('deleteAccount.steps.s3')}</li>
            </ol>
            <p className={styles['note']}>{t('deleteAccount.what')}</p>
            <p className={styles['note']}>{t('deleteAccount.contact')}</p>
            <div>
              <Button
                onClick={() => {
                  void navigate('/account/privacy');
                }}
              >
                {t('deleteAccount.open')}
              </Button>
            </div>
          </div>
        </Panel>
      </Page>
    </ScreenFrame>
  );
}
